import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';

import {DatetimeModule} from '../../components/datetime/datetime.module';
import {FieldsModule} from '../../components/fields/fields.module';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import {AngularMultiSelectModule} from '../../components/angular2-multiselect-dropdown/multiselect.component';
import {SettingsParkingPassesService} from '../../services/settings-parking-passes.service';
import {SettingsParkingPassesComponent} from './settings-parking-passes.component';
import {SettingsParkingRulesModalComponent} from './settings-parking-rules-modal/settings-parking-rules-modal.component';
import {SettingsParkingLotModalComponent} from './settings-parking-lot-modal/settings-parking-lot-modal.component';
import {SettingsParkingPassesRulesListComponent} from './settings-parking-passes-rules-list/settings-parking-passes-rules-list.component';
import {SettingsParkingPassesLotsListComponent} from './settings-parking-passes-lots-list/settings-parking-passes-lots-list.component';
import {SettingsParkingPassesDetailedViewComponent} from './settings-parking-passes-detailed-view/settings-parking-passes-detailed-view.component';
import {LegalAgreementModalComponent} from './legal-agreement-modal/legal-agreement-modal.component';
import {DisclaimerModalComponent} from './disclaimer-modal/disclaimer-modal.component';
import {PassNotificationModalComponent} from './pass-notification-modal/pass-notification-modal.component';
import {PassTypeModalComponent} from './pass-type-modal/pass-type-modal.component';
import {UtilsModule} from '../../modules/utils/utils.module';


@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        FieldsModule,
        AngularMaterialImportModule,
        AngularMultiSelectModule,
        UtilsModule
    ],
    declarations: [
        SettingsParkingPassesComponent,
        SettingsParkingPassesRulesListComponent,
        SettingsParkingPassesLotsListComponent,
        SettingsParkingLotModalComponent,
        SettingsParkingRulesModalComponent,
        SettingsParkingPassesDetailedViewComponent,
        LegalAgreementModalComponent,
        DisclaimerModalComponent,
        PassNotificationModalComponent,
        PassTypeModalComponent
    ],
    providers: [
        SettingsParkingPassesService
    ]
})
export class SettingsParkingPassesModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/settings-parking-passes/settings-parking-passes.module.ts